import { render, staticRenderFns } from "./CrmDashboard.vue?vue&type=template&id=5c31f5ba&scoped=true&"
import script from "./CrmDashboard.vue?vue&type=script&lang=js&"
export * from "./CrmDashboard.vue?vue&type=script&lang=js&"
import style0 from "./CrmDashboard.vue?vue&type=style&index=0&id=5c31f5ba&scoped=true&lang=css&"
import style1 from "./CrmDashboard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c31f5ba",
  null
  
)

export default component.exports